import { Order } from "../interfaces/Order";
import { flattenBookingsTree } from "./TreeHelper";

export function calculateQty(order: Order) : number
 {
  return  flattenBookingsTree(order.Booking).reduce((accumulator, booking) => accumulator + (booking.IsCheckedForApproval ? booking.Quantity : 0), 0)
 }